import { API_URL, APP_TITLE } from "../../config";
import { LoginPage as FobLoginPage, LocalLoginForm, SpidLoginForm } from "ra-friendsofbabba";
import { Link, Typography, makeStyles } from "@material-ui/core";
import React, { useMemo } from "react";

import logo from "../../assets/logo.png";
import theme from "../../theme";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
  help: {
    maxWidth: 300 - theme.spacing(2),
    margin: theme.spacing(2),
    display: "block",
    clear: "both",
    "& .MuiLink-root": {
      fontSize: 14,
    },
  },
  help2: {
    marginTop: theme.spacing(2),
  },
  link: {
    fontSize: 14,
  },
}));

const Alert = () => {
  const classes = useStyles();
  const translate = useTranslate();
  return (
    <div className={classes.help}>
      <Typography variant="body2">{translate("ra.auth.help")}</Typography>
      <Link variant="body2" className={classes.link} href="mailto:assistenza.stradaperstrada@regione.puglia.it">
        assistenza.stradaperstrada@regione.puglia.it
      </Link>

      <Typography variant="body2" className={classes.help2}>
        {translate("ra.auth.help2")}
      </Typography>
      <Link variant="body2" className={classes.link} href="mailto:stradaperstrada@pec.rupar.puglia.it">
        stradaperstrada@pec.rupar.puglia.it
      </Link>
    </div>
  );
};
const LoginPage = (props) => {
  const isStaff = useMemo(() => props.location.search.indexOf("type=staff") > -1, [props.location.search]);
  return (
    <FobLoginPage
      {...props}
      themeOverride={theme}
      logo={<img src={logo} width={200} alt={APP_TITLE} style={{ margin: "auto", display: "block" }} />}
    >
      {isStaff && <LocalLoginForm />}
      {!isStaff && <Alert />}
      <SpidLoginForm apiUrl={API_URL} signup={"#/signup"} />
    </FobLoginPage>
  );
};
export default LoginPage;
